import Card from '@mui/material/Card';
import React from 'react';

const ServiceLv1MetadataCard = (props) => {
  return (
    <Card variant='outlined' sx={{ width: '100%', height: '100%' }} >
      {props.children}
    </Card>
  );
}
export default ServiceLv1MetadataCard;
